"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.split");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

require("core-js/modules/es6.array.reduce");

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var nomarlize = function nomarlize(keys) {
  var keyList;

  if ((0, _isArray.default)(keys[0])) {
    keyList = keys[0];
  } else {
    keyList = keys;
  }

  return keyList.reduce(function (prev, key) {
    return (0, _toConsumableArray2.default)(prev).concat((0, _toConsumableArray2.default)((key + '').replace(/\[['"]/g, '[').replace(/\]|['"](?=\])/g, '').split(/[.[]/)));
  }, []);
};

function safeGet(target) {
  for (var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keys[_key - 1] = arguments[_key];
  }

  var value = target;

  if (!value || keys.length === 0) {
    return value;
  }

  keys = nomarlize(keys);
  keys.every(function (key) {
    value = value[key];
    return value !== void 0 && value !== null;
  });
  return value;
}

safeGet.default = safeGet;
var _default = safeGet;
exports.default = _default;
module.exports = exports["default"];